<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <b-alert
      variant="success"
      :show="messageObject.success.count"
      dismissible
      @dismissed="messageObject.success.count = 0"
      @dismiss-count-down="successCountChanged"
      >{{ messageObject.success.content }}
    </b-alert>
    <!-- <b-alert variant="warning" show>等待資訊</b-alert> -->
    <div class="Info_Area">
      <b-container fluid>
        <b-row align-h="between">
          <b-col cols="4">
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-icon icon="calendar3"></b-icon>
              </b-input-group-prepend>
              <datepicker
                v-model="date"
                min="1960-01-01"
                :max="maxdate"
              ></datepicker>
            </b-input-group>
          </b-col>
          <b-col style="margin-top:1rem;" cols="auto">
            <b-button @click="modalshow = !modalshow" variant="warning"
              >新增</b-button
            >
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col style="margin-top:1rem;">
                        <p>*以下資料皆屬於假資料</p>
                    </b-col>
                </b-row> -->
        <b-row>
          <b-col cols="auto">
            <b-table-simple>
              <b-thead head-variant="dark">
                <b-tr class="thead-dark">
                  <b-th>期作</b-th>
                  <b-th>鄉鎮別</b-th>
                  <b-th>收購單位</b-th>
                  <b-th>今日<br />收購量(噸)含公糧及自營糧</b-th>
                  <b-th>累加<br />收購量(噸)含公糧及自營糧</b-th>
                  <!-- <b-th colspan="2">濕度</b-th>
                  <b-th colspan="2">刈數(1刈=100台斤/分)</b-th>
                  <b-th colspan="2">價格(價格)</b-th> -->
                  <b-th>低濕度</b-th>
                  <b-th>高濕度</b-th>
                  <b-th>低刈數(每分地)</b-th>
                  <b-th>高刈數(每分地)</b-th>
                  <b-th>低價格(元/每百台斤)</b-th>
                  <b-th>高價格(元/每百台斤)</b-th>
                  <b-th>收割比例(%)</b-th>
                  <b-th>備註</b-th>
                  <b-th v-if="ifshowdelete">操作</b-th>
                </b-tr>
              </b-thead>
              <template v-if="!ifSorting">
                <b-tbody>
                  <b-tr
                    v-for="(item, index) in priceanalysis.items"
                    :key="index"
                  >
                    <b-td>
                      {{ item.RF_PERIOD == "001" ? "第一期" : "第二期" }}
                      <!-- <b-form-select v-model="item.PEROID" :options="ricefarm.periodoptions"></b-form-select> -->
                    </b-td>
                    <b-td>
                      {{ item.RF_TOWN }}
                      <!-- <b-form-select v-model="item.TOWNCATEGORY" :options="ricefarm.townoptions"></b-form-select> -->
                    </b-td>
                    <b-td>
                      {{ item.RF_UNIT == 0 ? "" : item.RF_UNIT }}
                      <!-- <b-form-input v-model="item.PURCHASEUNIT"  type="text"></b-form-input> -->
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_VOLUME"
                        style="width: 15vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <div v-b-tooltip.hover :title="item.ALLSUM">
                        {{ item.SUM }}
                      </div>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_HUM_L"
                        style="width: 8vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_HUM_H"
                        style="width: 8vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_MOW_L"
                        style="width: 8vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_MOW_H"
                        style="width: 8vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_PRICE_L"
                        style="width: 12vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_PRICE_H"
                        style="width: 12vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_RATIO"
                        style="width: 12vh;"
                        type="number"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-form-input
                        v-model="item.RF_NOTE"
                        style="width: 12vh;"
                        type="text"
                      ></b-form-input>
                    </b-td>
                    <b-td>
                      <b-button
                        v-if="ifshowdelete"
                        @click="removeProcess(item)"
                        variant="danger"
                        >刪除</b-button
                      >
                    </b-td>
                  </b-tr>
                </b-tbody>
              </template>
            </b-table-simple>
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-col>
            <b-button @click="savelist" variant="warning">儲存</b-button>
          </b-col>
        </b-row>
      </b-container>
      <!-- <b-modal title="新增品項" id="addCropModal" @hidden="hideModal" @ok="addProcess"> -->
      <b-modal
        size="lg"
        body-class="bmodal-body"
        v-model="modalshow"
        title="新增品項"
        id="addCropModal"
        hide-backdrop
        @hidden="hideModal"
        @ok="addProcess"
      >
        <b-form-group
          label="*請選擇期作"
          label-for="periodselect"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <b-form-select
            id="periodselect"
            v-model="ricefarm.object.period"
            :options="ricefarm.periodoptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          label="*請選擇鄉鎮"
          label-for="townselect"
          label-cols-sm="3"
          label-align-sm="right"
        >
          <b-form-select
            id="townselect"
            v-model="ricefarm.object.town"
            :options="ricefarm.townoptions"
            @input="getUnitOptions"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          label="*請選擇收購單位"
          label-for="unitselect"
          label-cols-sm="3"
          label-align-sm="right"
          v-if="ricefarm.unitoptions.length > 0"
        >
          <b-form-select
            id="unitselect"
            v-model="ricefarm.object.unit"
            :options="ricefarm.unitoptions"
          ></b-form-select>
        </b-form-group>
        <template #modal-footer="{ ok, cancel }">
          <b-button size="sm" variant="success" @click="ok()">
            儲存
          </b-button>
          <b-button size="sm" variant="warning" @click="cancel()">
            取消
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>
<script>
import datepicker from "@/components/Datepicker.vue";
import RICEFARMLIST from "@/data/RICE_FARM_CODE_LIST.json";

export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    var taiwanMaxDate = today
      .toLocaleString()
      .split(" ")[0]
      .split("/");
    taiwanMaxDate[0] = parseInt(taiwanMaxDate[0]) - 1911;
    taiwanMaxDate[1] =
      taiwanMaxDate[1].length == 1 ? 0 + taiwanMaxDate[1] : taiwanMaxDate[1];
    taiwanMaxDate[2] =
      taiwanMaxDate[2].length == 1 ? 0 + taiwanMaxDate[2] : taiwanMaxDate[2];
    return {
      num: 10,
      perPage: 5,
      id: this.$route.params.id,
      counter: 0,
      total: 0,
      date: null,
      currentPage: 1,
      editlist: [],
      local: "zh-tw",
      modalshow: false,
      ifSorting: false,
      iffirst: true,
      today: taiwanMaxDate.join("-"),
      maxdate: today
        .toLocaleString()
        .split(" ")[0]
        .split("/")
        .join("-"),
      // today: today.toLocaleString().split(' ')[0],
      // maxdate: today.toLocaleString().split(' ')[0].split('/').join('-'),
      filterSearch: null,
      selection: [],
      ricefarmlist: RICEFARMLIST,
      totalRows: 1,
      Token: null,
      TokenID:
        "4ImX7kJFJSGhLW14LiAP8bbfW7lpO8pvW8uZqIXhFvlhTVhwF4nXhrWjn7NatmmqGrFiKJTOaA40KO+eN0G6pQ==",
      isBusy: false,
      removeobj: {},
      filtervalue: null,
      datamanagement: {
        ifshow: false,
        ifedit: false,
      },
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#/",
        },
        {
          text: "資料管理",
          active: true,
        },
        {
          text: "稻作價格維護",
          href: "#/databuildforricefarm",
        },
        {
          text: this.$route.params.id == "add" ? "新增" : "編輯",
          active: true,
        },
      ],
      priceanalysis: {
        fields: [
          {
            key: "PEROID",
            label: "期作",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "TOWNCATEGORY",
            label: "鄉鎮別",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PURCHASEUNIT",
            label: "收購單位",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "PURCHASE",
            label: "收購量(噸)含公糧及自營糧",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MINWET",
            label: "低濕度",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MAXWET",
            label: "高濕度",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MINYIELD",
            label: "低刈數(每分地)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MAXYIELD",
            label: "高刈數(每分地)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MINPRICE",
            label: "低價格(元/每百台斤)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "MAXPRICE",
            label: "高價格(元/每百台斤)",
            thClass: "hideheadr",
            visible: true,
          },
          {
            key: "EDIT",
            label: "操作",
            thClass: "hideheadr",
            visible: true,
          },
        ],
        // allitems: [
        //     {
        //         DATE:"110-06-09",
        //         PEROID: "002",
        //         TOWNCATEGORY: "水上鄉",
        //         PURCHASEUNIT: "水上鄉農會",
        //         PURCHASE: "282",
        //         MINWET: 26,
        //         MAXWET: 27,
        //         MINYIELD: 20,
        //         MAXYIELD: 20,
        //         MINPRICE: 1000,
        //         MAXPRICE: 1000
        //     },
        //     {
        //         DATE:"110-06-09",
        //         PEROID: "001",
        //         TOWNCATEGORY: "水上鄉",
        //         PURCHASEUNIT: "順利糧食有限公司",
        //         PURCHASE: "505",
        //         MINWET: 26,
        //         MAXWET: 30,
        //         MINYIELD: 17,
        //         MAXYIELD: 20,
        //         MINPRICE: 980,
        //         MAXPRICE: 1020
        //     },
        //     {
        //         DATE:"110-06-08",
        //         PEROID: "001",
        //         TOWNCATEGORY: "民雄鄉",
        //         PURCHASEUNIT: "水上鄉農會",
        //         PURCHASE: "237",
        //         MINWET: 26,
        //         MAXWET: 27,
        //         MINYIELD: 22,
        //         MAXYIELD: 22,
        //         MINPRICE: 1000,
        //         MAXPRICE: 1030
        //     },
        //     {
        //         DATE:"110-06-08",
        //         PEROID: "001",
        //         TOWNCATEGORY: "水上鄉",
        //         PURCHASEUNIT: "順利糧食有限公司",
        //         PURCHASE: "385",
        //         MINWET: 26,
        //         MAXWET: 30,
        //         MINYIELD: 17,
        //         MAXYIELD: 20,
        //         MINPRICE: 980,
        //         MAXPRICE: 1020
        //     },
        //     {
        //         DATE:"109-11-26",
        //         PEROID: "002",
        //         TOWNCATEGORY: "水上鄉",
        //         PURCHASEUNIT: "水上鄉農會",
        //         PURCHASE: "73",
        //         MINWET: 25,
        //         MAXWET: 25,
        //         MINYIELD: 13,
        //         MAXYIELD: 13,
        //         MINPRICE: 940,
        //         MAXPRICE: 940
        //     },
        //     {
        //         DATE:"109-11-26",
        //         PEROID: "002",
        //         TOWNCATEGORY: "民雄鄉",
        //         PURCHASEUNIT: "順利糧食有限公司",
        //         PURCHASE: "1010",
        //         MINWET: 27,
        //         MAXWET: 28,
        //         MINYIELD: 0,
        //         MAXYIELD: 0,
        //         MINPRICE: 1010,
        //         MAXPRICE: 1010
        //     }
        // ],
        items: [],
        additem: {},
        removelist: [],
      },
      messageObject: {
        warning: {
          content: null,
          count: 0,
        },
        success: {
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      ricefarm: {
        periodoptions: [
          { text: "第一期", value: "001" },
          { text: "第二期", value: "002" },
        ],
        townoptions: [
          { text: "水上鄉", value: "水上鄉" },
          { text: "太保市", value: "太保市" },
          { text: "民雄鄉", value: "民雄鄉" },
          { text: "新港鄉", value: "新港鄉" },
          { text: "大林鎮", value: "大林鎮" },
          { text: "朴子市", value: "朴子市" },
          { text: "溪口鄉", value: "溪口鄉" },
          { text: "六腳鄉", value: "六腳鄉" },
          { text: "義竹鄉", value: "義竹鄉" },
          { text: "鹿草鄉", value: "鹿草鄉" },
          { text: "六腳鄉", value: "六腳鄉" },
          { text: "東石鄉", value: "東石鄉" },
          { text: "中埔鄉", value: "中埔鄉" },
          { text: "竹崎鄉", value: "竹崎鄉" },
        ],
        unitoptions: [],
        object: {
          period: null,
          town: null,
          unit: "",
        },
      },
      countrysortedlist: [
        "水上鄉",
        "鹿草鄉",
        "布袋鎮",
        "義竹鄉",
        "太保市",
        "新港鄉",
        "溪口鄉",
        "大林鎮",
        "民雄鄉",
        "朴子市",
        "六腳鄉",
        "東石鄉",
        "中埔鄉",
        "竹崎鄉",
      ],
      companysortedlist: [
        "水上鄉農會",
        "順利糧食有限公司",
        "鹿草鄉農會",
        "三合豐碾米廠分廠",
        "玉豐糧食股份有限公司(布袋合成碾米工廠)",
        "太保市農會",
        "新港鄉農會",
        "久長碾米工廠",
        "東興糧食工廠",
        "溪口鄉農會",
        "永昌碾米工廠",
        "大林鎮農會",
        "新聯豐碾米工廠",
        "豐益糧食公司",
        "民雄鄉農會",
        "和泰碾米工廠",
        "朴子市農會",
      ],
      ifshowdelete: false,
      ifprocess: false,
      apiToken: (data) => this.userRequest.post("/API/Default/Token", data),
      apiGetRiceFarmManagement: (data) =>
        this.userRequest.post("/API/Default/getRiceFarmManagement", data),
      apiUpdateRiceFarmManagement: (data) =>
        this.userRequest.post("/API/Default/RiceFarmManagementExecute", data),
    };
  },
  created() {
    // this.init()
    this.checkLogin();
  },
  mounted() {
    // this.checkLogin()
    // this.checkPermission()
  },
  components: {
    datepicker,
  },
  methods: {
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000019",
        fun: this.checkByPJID,
      });
      this.FunctionToken(this.Authority, {
        PJ_ID: "PJ000000000021",
        fun: this.checkByPJIDdelete,
      });
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        // window.addEventListener("resize", this.handleResize);
        // this.handleResize();
        this.init();
      }
    },
    checkByPJIDdelete(value) {
      if (value) this.ifshowdelete = true;
      else this.ifshowdelete = false;
    },
    //  checkLogin() {
    //     let TokenID = sessionStorage.getItem("TokenID");
    //     if(TokenID){
    //         this.checkPermission()
    //     }
    //     else
    //     {
    //         alert("無權限檢視此頁面，請登入帳號")
    //         this.$router.push({ path: '/login' })
    //     }
    // },
    updateRiceFarmManagement(data) {
      this.apiUpdateRiceFarmManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.counter++;
            this.checkIfdone();
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getRiceFarmManagement(data) {
      this.apiGetRiceFarmManagement(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.priceanalysis.items = [];
            if (jsonData.length > 0) {
              jsonData.forEach((z) => {
                z.index = this.countrysortedlist.indexOf(z.RF_TOWN);
                z.comapnyindex =
                  this.companysortedlist.indexOf(z.RF_UNIT) == -1
                    ? 99
                    : this.companysortedlist.indexOf(z.RF_UNIT);
              });

              jsonData.sort((a, b) => {
                return a.index == b.index
                  ? a.comapnyindex - b.comapnyindex
                  : a.index - b.index;
              });
              let list = [];
              for (let g in jsonData) {
                let subitem = jsonData[g];
                subitem["ifshow"] = false;
                let sumlist1 = subitem.RF_VOLUME_SUM.split(",");
                let sumlist2 = [];
                let sum = 0;
                sumlist1.forEach((x) => {
                  if (
                    x != "" &&
                    x != null &&
                    x != 0 &&
                    x != undefined &&
                    x != "undefined"
                  ) {
                    sumlist2.push(x);
                    sum += parseInt(x);
                  }
                });
                subitem["SUM"] = sum;
                subitem["ALLSUM"] = sumlist2.join("+");
                if (subitem.RF_DELETE == 0) {
                  list.push(subitem);
                }
              }
              this.priceanalysis.items = JSON.parse(JSON.stringify(list));
              this.priceanalysis.items.sort((a, b) => {
                let y = (a.RF_CDATE > b.RF_CDATE) - (a.RF_CDATE < b.RF_CDATE);
                return y;
              });
            }
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    init() {
      this.date = this.id == "add" ? this.today : this.id;
      // let localmintime = this.date.split("-");
      // localmintime[0] = parseInt(localmintime[0]) + 1911;
      // let obj = {
      //   RF_CDATE: localmintime.join("-"),
      // };

      // this.FunctionToken(this.getRiceFarmManagement, obj);
      //this.datechange();
    },
    gettestdata() {
      this.priceanalysis.items = [];
      this.priceanalysis.allitems.forEach((x) => {
        if (x.DATE == this.date) this.priceanalysis.items.push(x);
      });
    },
    onEnd() {
      for (let j in this.priceanalysis.items) {
        let item1 = this.priceanalysis.items[j];
        item1["CM_SORT"] = parseInt(j) + 1;
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`)
      // let y = ymd
      const weekday = date.getDay();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
    removeProcess(item) {
      if (confirm("確定要刪除品項?")) {
        if (this.IsNull(item["RF_ID"]) != "") {
          this.priceanalysis.removelist.push(item);
        }
        let index = this.priceanalysis.items.findIndex((y) => y == item);
        this.priceanalysis.items.splice(index, 1);
      }
    },
    savelist() {
      if (!this.ifprocess) {
        this.ifprocess = true;
        this.counter = 0;
        this.total =
          this.priceanalysis.removelist.length +
          this.priceanalysis.items.length;
        this.editlist = [];
        let datelist1 = [];
        if (this.priceanalysis.items.length != 0) {
          let count = 0;
          let subdate = this.priceanalysis.items[0].RF_CDATE;
          if (subdate.includes("T")) {
            datelist1 = this.priceanalysis.items[0].RF_CDATE.split(
              "T"
            )[0].split("-");
          } else {
            datelist1 = this.priceanalysis.items[0].RF_CDATE.split("-");
          }

          let datelist2 = this.date.split("-");
          datelist2[0] = parseInt(datelist2[0]) + 1911;
          if (datelist2[1].length == 1 && datelist1[1].charAt(0) == "0") {
            datelist1[1] = datelist1[1].charAt(1);
          }
          if (datelist2[2].length == 1 && datelist1[2].charAt(0) == "0") {
            datelist1[2] = datelist1[2].charAt(1);
          }
          for (let k in datelist1) {
            if (datelist1[k] == datelist2[k]) {
              count++;
            }
          }
          if (count == 3) {
            for (let j in this.priceanalysis.items) {
              let obj = this.priceanalysis.items[j];
              if (obj["SUM"] == 0) {
                obj["RF_VOLUME_SUM"] = obj["RF_VOLUME"];
              } else {
                obj["RF_VOLUME_SUM"] =
                  obj["RF_VOLUME_SUM"] + "," + obj["RF_VOLUME"];
              }
              // this.total++
              this.FunctionToken(this.updateRiceFarmManagement, obj);
            }
          } else if (count != 3) {
            for (let i in this.priceanalysis.items) {
              let obj = this.priceanalysis.items[i];
              if (obj["SUM"] == 0) {
                obj["RF_VOLUME_SUM"] = obj["RF_VOLUME"];
              } else {
                obj["RF_VOLUME_SUM"] =
                  obj["RF_VOLUME_SUM"] + "," + obj["RF_VOLUME"];
              }
              obj["RF_CDATE"] = datelist2.join("-");
              obj["RF_ID"] = null;
              // this.total++
              this.FunctionToken(this.updateRiceFarmManagement, obj);
            }
          }
        }

        if (this.priceanalysis.removelist.length != 0) {
          for (let l in this.priceanalysis.removelist) {
            let obj = this.priceanalysis.removelist[l];
            // if (obj["SUM"] == 0) {
            //   obj["RF_VOLUME_SUM"] = obj["RF_VOLUME"];
            // } else {
            //   obj["RF_VOLUME_SUM"] =
            //     obj["RF_VOLUME_SUM"] + "," + obj["RF_VOLUME"];
            // }
            obj["RF_DELETE"] = 1;
            // this.total++
            this.FunctionToken(this.updateRiceFarmManagement, obj);
          }
        }
      }
    },
    checkIfdone() {
      if (this.counter == this.total) {
        this.suceessPopUp("儲存成功");
        this.$router.push({ name: "DataBuildForRiceFarm" });
      }
    },
    // async checkPermission()
    // {
    //     let accountdata = {PJ_ID: 'PJ000000000014', fun:this.checkshowByPJID}
    //     this.FunctionToken(this.Authority, accountdata)
    //     let databuilddata = {PJ_ID: 'PJ000000000015', fun:this.checkeditdataByPJID}
    //     this.FunctionToken(this.Authority, databuilddata)
    // },
    // checkshowByPJID(value)
    // {
    //     if(!value)
    //     {
    //         alert("無權限檢視此頁面，將返回首頁")
    //         this.datamanagement.ifshow = false
    //         this.$router.push({ path: '/' })

    //     }
    //     else
    //     {
    //         this.datamanagement.ifshow = true
    //         this.FunctionToken(this.getTradeWarningCrop, {})
    //     }
    // },
    // checkeditdataByPJID(value) {
    //     if(!value)
    //         {
    //             this.datamanagement.ifedit = false
    //         }
    //         else
    //         {
    //             this.datamanagement.ifedit = true
    //         }
    // },
    checksave() {
      this.$router.push({ name: "DataBuildForRiceFarm" });
    },
    hideModal() {
      this.ricefarm.unitoptions = [];
      this.ricefarm.object = {
        period: null,
        town: null,
        unit: "",
      };
      this.modalshow = false;
    },
    getUnitOptions() {
      let index = this.ricefarmlist.findIndex(
        (x) => x.FM_TOWN == this.ricefarm.object.town
      );
      if (index != -1) {
        this.ricefarm.object.unit = "";
        this.ricefarm.unitoptions = this.ricefarmlist[index].FM_LIST;
      }
    },
    addProcess() {
      let maindate = this.date.split("-");
      maindate[0] =
        parseInt(maindate[0]) < 1911
          ? parseInt(maindate[0]) + 1911
          : maindate[0];
      let obj = {
        RF_CDATE: maindate.join("-"),
        RF_PERIOD: this.ricefarm.object.period,
        RF_TOWN: this.ricefarm.object.town,
        RF_UNIT: this.ricefarm.object.unit,
        RF_VOLUME: 0,
        RF_HUM_L: 0,
        RF_HUM_H: 0,
        RF_MOW_L: 0,
        RF_MOW_H: 0,
        RF_PRICE_L: 0,
        RF_PRICE_H: 0,
        RF_RATIO: 0,
        RF_NOTE: null,
        RF_DELETE: 0,
        SUM: 0,
      };
      this.priceanalysis.items.push(obj);
    },
    addcount() {
      for (let i in this.priceanalysis.items) {
        this.priceanalysis.items[i]["Count"] = parseInt(i) + 1;
      }
    },
    datechange() {
      let localmintime = this.date.split("-");
      localmintime[0] = parseInt(localmintime[0]) + 1911;
      let obj = {
        RF_CDATE: localmintime.join("-"),
      };
      this.FunctionToken(this.getRiceFarmManagement, obj);
    },
    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     this.currentPage = 1
    // },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.messageObject.dismissSecs;
      this.messageObject.success.content = msg;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
  },
  computed: {
    visibleFields() {
      return this.priceanalysis.fields.filter((field) => field.visible);
    },
  },
  watch: {
    date() {
      if (!this.iffirst) {
        this.datechange();
      }
      this.iffirst = false;
    },
  },
  // watch: {
  //     'date'()
  //     {
  //         this.gettestdata()
  //     }
  // }
};
</script>

<style scoped>
.table thead th {
  vertical-align: middle !important;
}
.hideheadr {
  background-color: red !important;
}
</style>
